import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { LoginEmailComponent  } from './auth/login-email/login-email.component';
import { RegisterFormComponent } from './auth/register-form/register-form.component';
import { AuthIndexComponent } from './auth/auth-index/auth-index.component';
import { LinkedinResponseComponent } from './auth/linkedin-response/linkedin-response.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { GoogleResponseComponent } from './auth/google-response/google-response.component';
import { LoginAsComponent  } from './auth/login-as/login-as.component'
//pages - News Feed / Home
import { NewsFeedComponent } from './views/newsfeed/news-feed/news-feed.component';
import { NotificationComponent } from './views/newsfeed/notification/notification.component';
import { PostComponent } from './views/newsfeed/post/post.component';
import { SharedDocumentsComponent } from './views/newsfeed/shared-documents/shared-documents.component';
import { SharedDocumentDetailComponent  } from './views/newsfeed/shared-document-detail/shared-document-detail.component';
//pages - profile
import { ProfileMyprofileComponent } from './views/profile/profile-myprofile/profile-myprofile.component';
import { ProfileConnectionsComponent } from './views/profile/profile-connections/profile-connections.component';
import { ProfileCertificatesComponent } from './views/profile/profile-certificates/profile-certificates.component'
import { ProfileUserDataComponent } from './views/profile/profile-user-data/profile-user-data.component';
import { ProfileEditComponent } from './views/profile/profile-edit/profile-edit.component';
import { ProfileChangePasswordComponent } from './views/profile/profile-change-password/profile-change-password.component'
import { ProfileChangeProfilePicturesComponent } from './views/profile/profile-change-profile-pictures/profile-change-profile-pictures.component';

//Articles
import { ArticlesAllComponent } from './views/articles/articles-all/articles-all.component';
import { ArticlesDetailComponent } from './views/articles/articles-detail/articles-detail.component';
import { ArticlesCreateComponent } from './views/articles/articles-create/articles-create.component';

//Others
import { ReachUsComponent  } from './views/others/reach-us/reach-us.component';

//pages - feedback
import { FeedbackDashboardComponent } from './views/feedback/feedback-dashboard/feedback-dashboard.component';
import { FeedbackSubmitComponent } from './views/feedback/feedback-submit/feedback-submit.component';
import { FeedbackDetailComponent } from './views/feedback/feedback-detail/feedback-detail.component';

//pages - Request
import { RequestDashboardComponent } from './views/request/request-dashboard/request-dashboard.component';
import { RequestSubmitComponent } from './views/request/request-submit/request-submit.component';
import { RequestDetailComponent } from './views/request/request-detail/request-detail.component';
import { RequestSubmitSupportComponent } from './views/request/request-submit-support/request-submit-support.component';
import { RequestSubmitProfileComponent } from './views/request/request-submit-profile/request-submit-profile.component';
import { RequestAdminAllComponent } from './views/request/request-admin-all/request-admin-all.component';
import { RequestAdminDetailComponent } from './views/request/request-admin-detail/request-admin-detail.component';

//pages - Support
import { SupportDashboardComponent } from './views/support/support-dashboard/support-dashboard.component'
import { SupportNewCaseComponent } from './views/support/support-new-case/support-new-case.component';
import { SupportCasesComponent } from './views/support/support-cases/support-cases.component'
import { SupportInstantHelpComponent } from './views/support/support-instant-help/support-instant-help.component'
import { SupportCaseDetailComponent } from './views/support/support-case-detail/support-case-detail.component';
import { SupportNewAdvancedCaseComponent } from './views/support/support-new-advanced-case/support-new-advanced-case.component'

//pages - Discussions
import { DiscussionsAllComponent } from './views/discussions/discussions-all/discussions-all.component';
import { DiscussionsSubmitComponent } from './views/discussions/discussions-submit/discussions-submit.component'
import { DiscussionsDetailComponent } from './views/discussions/discussions-detail/discussions-detail.component'

//pages - services
import { ServicesDashboardComponent } from './views/services/services-dashboard/services-dashboard.component';
import { ServicesNewSdrComponent } from './views/services/services-new-sdr/services-new-sdr.component';
import { ServicesPoComponent } from './views/services/services-po/services-po.component';
import { ServicesSdrsComponent } from './views/services/services-sdrs/services-sdrs.component';
import { ServicesSdrDetailsComponent } from './views/services/services-sdr-details/services-sdr-details.component';

//pages - groups
import { GroupsAllComponent } from './views/groups/groups-all/groups-all.component';
import { GroupsDetailComponent } from './views/groups/groups-detail/groups-detail.component';
import { GroupsAll2Component } from './views/groups/groups-all2/groups-all2.component';

//pahes - forms
import { FormsAllComponent } from './views/forms/forms-all/forms-all.component';
import { FormsViewComponent } from './views/forms/forms-view/forms-view.component';

//pages - Store
import { StoreInfoComponent } from './views/store/store-info/store-info.component';

//pages - static
import { StaticPageComponent } from './views/static/static-page/static-page.component';

//pages - redirect
import { RedirectDocumentComponent } from './views/redirect/redirect-document/redirect-document.component';

//pages - gistec
import { GistecDashboardComponent } from './views/gistec/gistec-dashboard/gistec-dashboard.component';
import { InternalRequestDetailsComponent } from './views/gistec/internal-request/internal-request-details/internal-request-details.component';
import { InternalRequestListComponent } from './views/gistec/internal-request/internal-request-list/internal-request-list.component';
import { InternalRequestSubmitComponent } from './views/gistec/internal-request/internal-request-submit/internal-request-submit.component';
import { ContactSearchComponent } from './views/gistec/contact/contact-search/contact-search.component';
import { DocumentListComponent } from './views/gistec/document/document-list/document-list.component';
import { UploadDocumentComponent } from './views/gistec/document/upload-document/upload-document.component';
import { DocumentDetailComponent } from './views/gistec/document/document-detail/document-detail.component';

import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";


import { AdminGuard } from './shared/guard/admin.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/default',
    pathMatch: 'full'
    },
    {
        path: 'auth', component: AuthIndexComponent, children: [
            {
                path: '',
                component: LoginEmailComponent
            },
            {
                path: 'login-as',
                component: LoginAsComponent
            },
            {
                path: 'login',
                component: LoginComponent
            },
            {
                path: 'login-email',
                component: LoginEmailComponent
            },
            {
                path: 'register',
                component: RegisterFormComponent
            },
            {
                path: 'linkedin',
                component: LinkedinResponseComponent
            },
            {
                path: 'google',
                component: GoogleResponseComponent
            },
            {
                path: 'contactus',
                component: ContactUsComponent
            }
        ]
    },
  //{
  //  path: '',
  //  component: ContentComponent,
  //  canActivate: [AdminGuard],
  //  children: content
  //},
    {
        path: '',
        component: ContentComponent,
        canActivate: [AdminGuard],
        children: [

            {
                path: 'd/:id', component: RedirectDocumentComponent            
            },
            {
                path: 'home', children: [
                    { path: 'news-feed', component: NewsFeedComponent },
                    { path: 'notification', component: NotificationComponent },
                    { path: 'post/:id', component: PostComponent },
                    { path: 'documents', component: SharedDocumentsComponent },
                    { path: 'document/:id', component: SharedDocumentDetailComponent },
                    { path: 'myprofile', component: ProfileMyprofileComponent },
                    { path: 'connections', component: ProfileConnectionsComponent },
                    { path: 'certificates', component: ProfileCertificatesComponent },
                    { path: 'user-profile/:id', component: ProfileUserDataComponent },
                    { path: 'edit', component: ProfileEditComponent },
                    { path: 'changePassword', component: ProfileChangePasswordComponent },
                    { path: 'changeProfilePicture', component: ProfileChangeProfilePicturesComponent }
                ]
            },
            {
                path: 'profile', children: [
                    { path: 'myprofile', component: ProfileMyprofileComponent },
                    { path: 'connections', component: ProfileConnectionsComponent },
                    { path: 'certificates', component: ProfileCertificatesComponent },
                    { path: 'user-profile/:id', component: ProfileUserDataComponent },
                    { path: 'edit', component: ProfileEditComponent },
                    { path: 'changePassword', component: ProfileChangePasswordComponent },
                    { path: 'changeProfilePicture', component: ProfileChangeProfilePicturesComponent }
                ]
            },
            {
                path: 'support', children: [
                    { path: 'dashboard', component: SupportDashboardComponent },
                    { path: 'submit', component: SupportNewCaseComponent },
                    { path: 'resubmit/:id', component: SupportNewCaseComponent },
                    { path: 'advsubmit', component: SupportNewAdvancedCaseComponent },
                    { path: 'cases', component: SupportCasesComponent },
                    { path: 'instant-help', component: SupportInstantHelpComponent },
                    { path: 'support-case-details/:id', component: SupportCaseDetailComponent }
                ]
            },
            {
                path: 'articles', children: [
                    { path: 'all', component: ArticlesAllComponent },
                    { path: 'detail/:id', component: ArticlesDetailComponent },
                    { path: 'create', component: ArticlesCreateComponent }
                ]
            },
            {
                path: 'others', children: [
                    { path: 'reach-us', component: ReachUsComponent }
                ]
            },
            {
                path: 'feedback', children: [
                    { path: 'dashboard', component: FeedbackDashboardComponent },
                    { path: 'submit', component: FeedbackSubmitComponent },
                    { path: 'detail/:id', component: FeedbackDetailComponent }

                ]
            },
            {
                path: 'request', children: [
                    { path: 'dashboard', component: RequestDashboardComponent },
                    { path: 'submit', component: RequestSubmitComponent },
                    { path: 'supportsubmit', component: RequestSubmitSupportComponent },
                    { path: 'profilesubmit', component: RequestSubmitProfileComponent },
                    { path: 'all', component: RequestAdminAllComponent },
                    { path: 'detail/:id', component: RequestDetailComponent },
                    { path: 'detailad/:id', component: RequestAdminDetailComponent }

                ]
            },
            {
                path: 'form', children: [
                    { path: 'all', component: FormsAllComponent },
                    { path: 'detail/:code', component: FormsViewComponent }
                ]
            },
            {
                path: 'store',  children: [
                    { path: 'info', component: StoreInfoComponent }
                ]
            },
            {
                path: 'services', children: [
                    { path: 'dashboard', component: ServicesDashboardComponent },
                    { path: 'all', component: ServicesSdrsComponent },
                    { path: 'submit', component: ServicesNewSdrComponent },
                    { path: 'po', component: ServicesPoComponent },
                    { path: 'service-sdr-details/:id', component: ServicesSdrDetailsComponent }
                ]
            },
            {
                path: 'discussion',  children: [
                    { path: 'all', component: DiscussionsAllComponent },
                    { path: 'submit', component: DiscussionsSubmitComponent },
                    { path: 'detail/:id', component: DiscussionsDetailComponent }
                ]
            },
            {
                path: 'groups',  children: [
                    { path: 'allold', component: GroupsAllComponent },
                    { path: 'all', component: GroupsAll2Component },
                    { path: 'detail/:id', component: GroupsDetailComponent }
                ]
            },
            {
                path: 'static' , children: [
                    { path: 'page/:code', component: StaticPageComponent }
                ]
            },
            {
                path: 'gistec', children: [
                    { path: 'dashboard', component: GistecDashboardComponent },
                    {
                        path: 'request', children: [
                            { path: 'all', component: InternalRequestListComponent },
                            { path: 'detail/:id', component: InternalRequestDetailsComponent },
                            { path: 'submit', component: InternalRequestSubmitComponent }
                        ]
                    },
                    {
                        path: 'contact', children: [
                            { path: 'search', component: ContactSearchComponent }
                        ]
                    },
                    {
                        path: 'document', children: [
                            { path: 'list', component: DocumentListComponent },
                            { path: 'upload', component: UploadDocumentComponent },
                            { path: 'detail/:id', component: DocumentDetailComponent }
                        ]
                    }
                ]
            }
            
        ]
    },
  
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
})],
],
  exports: [RouterModule]
})
export class AppRoutingModule { }
